module.exports = "pegasus/assets/circle_icn_2.png";